import React, { useEffect, useRef } from "react";
import ScrollToTop from "../components/ScrollToTop";
import HelmetComponent from "../components/Helmet";

const PrivacyPolicy = () => {
    const PrivacySection = useRef(null);

    useEffect(() => {
        if (PrivacySection.current) {
            PrivacySection.current.scrollIntoView({ behavior: "smooth" });

        }
    }, []);
    return (
        <>
            <div className="max-md:px-4 lg:px-5 xl:px-5 py-4 scroll-mt-[90px]" ref={PrivacySection}>
                <HelmetComponent
                    title="Privacy Policy | Shri Radhe Holidays"
                    description="Read the privacy policy of Shri Radhe Holidays to understand how we collect, use and protect customer information, booking details and personal data."
                    url="https://www.shriradheholidays.com/privacypolicy"
                />

                <h1 className="  playfair-display font-extrabold py-[6px] px-2 max-sm:text-xl xl:text-2xl text-white  text-start border-l-8 rounded-r-full bg-[#0B1C3D]  border-[#D4AF37] wow fadeInUp max-sm:w-[70%] xl:w-[50%] transform -skew-x-12"
                    style={{ boxShadow: ' 0px 0px 20px 5px  rgb(0 0 0 / 32%)' }}
                >
                    Privacy Policy
                </h1>
                <div className="max-md:px-3 lg:px-3 xl:px-3">
                    {/* <h1 className="mb-4 text-[#D4AF37] playfair-display" style={{ fontWeight: "bolder" }}>Your Privacy Matters</h1> */}
                    <p className="mb-4 mt-4 text-justify poppins">
                        At <strong className="text-[#D4AF37]">Shri Radhe Holidays</strong>, we are committed to safeguarding your privacy. This policy outlines how we collect, use, and protect your personal information when you use our services.
                    </p>

                    <h3 className="h4 mb-3 playfair-display  " style={{ fontWeight: "bolder" }}>Information We Collect</h3>
                    <p className="mb-4 text-justify poppins">
                        We collect various types of personal data, including:
                    </p>
                    <ul style={{ marginBottom: "3rem", paddingLeft: "20px", listStyleType: "disc" }}>
                        <li className="poppins">Your name, email, phone number, and address when you make a booking.</li>
                        <li className="poppins">Payment details for processing transactions securely.</li>
                        <li className="poppins">Browsing data, including cookies, to enhance user experience.</li>
                    </ul>

                    <h3 className="h4 mb-3 playfair-display" style={{ fontWeight: "bolder" }}>How We Use Your Information</h3>
                    <p className="mb-4 text-justify poppins">
                        Your information is used for:
                    </p>
                    <ul style={{ marginBottom: "3rem", paddingLeft: "20px", listStyleType: "disc" }}>
                        <li className="poppins">Processing bookings and inquiries.</li>
                        <li className="poppins">Providing customer support and travel-related updates.</li>
                        <li className="poppins">Improving our website and services.</li>
                        <li className="poppins">Marketing and promotional communications (you can opt out anytime).</li>
                    </ul>

                    <h3 className="h4 mb-3 playfair-display" style={{ fontWeight: "bolder" }}>Data Security</h3>
                    <p className="mb-4 text-justify poppins">
                        We implement strict security measures to protect your personal data from unauthorized access, alteration, or disclosure.
                    </p>

                    <h3 className="h4 mb-3 playfair-display" style={{ fontWeight: "bolder" }}>Third-Party Sharing</h3>
                    <p className="mb-4 text-justify poppins">
                        We do not sell or rent your personal data. However, we may share necessary details with trusted partners for booking purposes, payment processing, and compliance with legal requirements.
                    </p>

                    <h3 className="h4 mb-3 playfair-display" style={{ fontWeight: "bolder" }}>Your Rights</h3>
                    <p className="mb-4 text-justify poppins">
                        You have the right to access, update, or delete your personal information. If you have any concerns about your data, please contact us.
                    </p>

                    <h3 className="h4 mb-3 playfair-display" style={{ fontWeight: "bolder" }}>Updates to This Policy</h3>
                    <p className="mb-4 text-justify poppins">
                        We may update this Privacy Policy periodically. Please check this page regularly to stay informed.
                    </p>

                    {/* Footer Section */}
                    {/* <div className="text-center mt-8">
                        <p className="dancing-script-font text-4xl md:text-6xl text-[#86B817] ">
                            Shri Radhe Holidays
                        </p>
                        <p className="text-sm md:text-lg hanuman-regular">
                            Where Every Trip Feels Divine.
                        </p>
                    </div> */}
                </div>
            </div>
            <ScrollToTop />
        </>
    );
};

export default PrivacyPolicy;